<template>
  <div style="min-height:300px">
    <div id="jquery-accordion-menu" class="jquery-accordion-menu">
      <ul>
        <li>
          <a
            v-on:click="isActiveCategory = !isActiveCategory"
            v-bind:class="{ 'submenu-indicator-minus': isActiveCategory }"
            data-toggle="collapse"
            href="#categories"
            role="button"
            aria-expanded="false"
            aria-controls="categories"
            >{{ $t("main.category") }}
            <span class="submenu-indicator">+</span></a
          >
        </li>
        <ul class="collapse multi-collapse" id="categories">
          <li v-for="category in parentCategories" v-bind:key="category.id">
            <a
              v-on:click="isActiveSubCategory = !isActiveSubCategory"
              v-bind:class="{
                'submenu-indicator-minus': isActiveSubCategory,
              }"
              data-toggle="collapse"
              :href="'#multiCollapseSubcategory' + category.id"
              role="button"
              aria-expanded="false"
              aria-controls="multiCollapseSubcategory"
              >{{ category.name }} <span class="submenu-indicator">+</span></a
            >
            <ul
              class="collapse multi-collapse"
              :id="'multiCollapseSubcategory' + category.id"
            >
              <li
                v-for="subCategory in subCategories(category.id)"
                :key="subCategory.id"
              >
                <a class="subcategory-link" href="#">
                  {{ subCategory.name }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      categories: this.$store.state.categories,
      isActiveCategory: false,
      isActiveSubCategory: false,
    };
  },
  methods: {
    subCategories(categoryId) {
      return this.categories.categories.filter(
        (i) => i.parent_id != 0 && categoryId == i.parent_id
      );
    },
  },
  computed: {
    parentCategories() {
      return this.categories.categories.filter((i) => i.parent_id == 0);
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/bigMenu.css";
</style>
